"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Packages */

/* Icon Itself */
var IconTransfer = function IconTransfer(props) {
  /**
   * Inherit props
   */
  var size = props.size,
      width = props.width,
      height = props.height,
      color = props.color;
  /**
   * Render
   */

  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width || size,
    height: height || size,
    viewBox: "0 0 30 30"
  }, _react.default.createElement("g", {
    id: "aph-icon-group-transfer",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("path", {
    id: "aph-icon-path-transfer",
    fill: color,
    transform: "translate(14.992641, 14.985028) rotate(-90.000000) translate(-14.992641, -14.985028)",
    d: "M11.206603,8.37817585 C11.2271209,8.45799335 11.2380326,8.54166506 11.2380326,8.62788535 L11.2380326,19.9850282 C11.2380326,20.537313 10.7903174,20.9850282 10.2380326,20.9850282 C9.68574787,20.9850282 9.23803262,20.537313 9.23803262,19.9850282 L9.23803262,8.62788535 C9.23803262,8.54608042 9.24785541,8.46656973 9.26638585,8.3904684 L6.70710678,10.9497475 C6.31658249,11.3402718 5.68341751,11.3402718 5.29289322,10.9497475 C4.90236893,10.5592232 4.90236893,9.9260582 5.29289322,9.53553391 L9.53553391,5.29289322 C9.9260582,4.90236893 10.5592232,4.90236893 10.9497475,5.29289322 L15.1923882,9.53553391 C15.5829124,9.9260582 15.5829124,10.5592232 15.1923882,10.9497475 C14.8018639,11.3402718 14.1686989,11.3402718 13.7781746,10.9497475 L11.206603,8.37817585 Z M20.6984202,21.6000634 L23.2781746,19.0203089 C23.6686989,18.6297847 24.3018639,18.6297847 24.6923882,19.0203089 C25.0829124,19.4108332 25.0829124,20.0439982 24.6923882,20.4345225 L20.4497475,24.6771632 C20.0592232,25.0676875 19.4260582,25.0676875 19.0355339,24.6771632 L14.7928932,20.4345225 C14.4023689,20.0439982 14.4023689,19.4108332 14.7928932,19.0203089 C15.1834175,18.6297847 15.8165825,18.6297847 16.2071068,19.0203089 L18.7740013,21.5872035 C18.7505574,21.5022863 18.7380326,21.4128383 18.7380326,21.3204649 L18.7380326,9.98502821 C18.7380326,9.43274346 19.1857479,8.98502821 19.7380326,8.98502821 C20.2903174,8.98502821 20.7380326,9.43274346 20.7380326,9.98502821 L20.7380326,21.3204649 C20.7380326,21.417514 20.7242078,21.5113341 20.6984202,21.6000634 Z"
  })));
};
/* Exporting */


var _default = IconTransfer;
exports.default = _default;